export default __webpack_public_path__ + "static/media/galaxy-grey.8e6a4805.svg";